'use client';

import { usePathname } from 'next/navigation';
import { type PropsWithChildren, useMemo } from 'react';

import { CasinoClockUTC } from '@/modules/common';

const noFooterPages = ['/game/'];

export function FooterWrapper({ children }: PropsWithChildren) {
  const pathname = usePathname();
  const isFooterHidden = useMemo(
    () => noFooterPages.some((p) => pathname.includes(p)),
    [pathname]
  );

  if (isFooterHidden) return null;

  return (
    <>
      <CasinoClockUTC />
      {children}
    </>
  );
}
